import { useEffect, useRef } from 'react';
import './VoiceOrb.css';

export default function VoiceOrb({ state, volume, onToggle, error }) {
  const barsRef = useRef([]);
  const animRef = useRef(null);
  const volRef  = useRef(0);
  const tRef    = useRef(0);

  useEffect(() => { volRef.current = volume; }, [volume]);

  useEffect(() => {
    cancelAnimationFrame(animRef.current);

    if (state === 'listening') {
      const go = () => {
        barsRef.current.forEach((b,i) => {
          if (!b) return;
          const n = Math.sin(Date.now()*0.012 + i*1.1)*0.5+0.5;
          b.style.height = Math.round(3 + (volRef.current/70)*22*n) + 'px';
        });
        animRef.current = requestAnimationFrame(go);
      };
      go();
    } else if (state === 'speaking') {
      // Onde sinusoidali animate mentre Sirus parla
      const go = () => {
        tRef.current += 0.08;
        barsRef.current.forEach((b,i) => {
          if (!b) return;
          const h = 4 + Math.abs(Math.sin(tRef.current + i * 0.7)) * 16;
          b.style.height = Math.round(h) + 'px';
        });
        animRef.current = requestAnimationFrame(go);
      };
      go();
    } else {
      barsRef.current.forEach(b => { if(b) b.style.height='3px'; });
    }

    return () => cancelAnimationFrame(animRef.current);
  }, [state]);

  const label = {
    idle:       '[ TOCCA PER PARLARE ]',
    listening:  '[ ASCOLTO — TOCCA PER FERMARE ]',
    processing: '[ ELABORAZIONE... ]',
    speaking:   '[ SIRUS — TOCCA PER INTERROMPERE ]',
  }[state] || '[ TOCCA PER PARLARE ]';

  return (
    <div className="voice-section">
      <div className={`orb-wrap ${state}`} onClick={onToggle}>
        <div className="orb-ring r1"/>
        <div className="orb-ring r2"/>
        <div className="orb-ring r3"/>
        <div className={`orb-core ${state}`}>
          {state === 'processing'
            ? <div className="spinner"/>
            : state === 'speaking'
            ? <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                {/* Speaker icon */}
                <polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill="#000" stroke="#000" strokeWidth="0.5"/>
                <path d="M15.54 8.46a5 5 0 0 1 0 7.07" stroke="#000" strokeWidth="1.8" strokeLinecap="round"/>
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14" stroke="#000" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            : <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M12 1a4 4 0 0 1 4 4v7a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4z"
                  fill={state==='listening'?'#000':'none'}
                  stroke={state==='listening'?'#000':'var(--green)'} strokeWidth="1.5"/>
                <path d="M19 10v2a7 7 0 0 1-14 0v-2"
                  stroke={state==='listening'?'#000':'var(--green)'} strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="12" y1="19" x2="12" y2="23"
                  stroke={state==='listening'?'#000':'var(--green)'} strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="8"  y1="23" x2="16" y2="23"
                  stroke={state==='listening'?'#000':'var(--green)'} strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
          }
        </div>
      </div>

      <div className={`waveform ${(state==='listening'||state==='speaking')?'on':''}`}>
        {Array.from({length:9}).map((_,i)=>(
          <div key={i} className={`wbar ${state==='speaking'?'wbar-speak':''}`}
            ref={el=>barsRef.current[i]=el}/>
        ))}
      </div>

      <div className={`vlabel ${state}`}>{label}</div>
      {error && <div className="verror">{error}</div>}
    </div>
  );
}
